export default __webpack_public_path__ + "static/media/map.e1066140.svg";